import { IAppState } from "../../../app/appTypes"

export const mfaSmsRequesting = (state: IAppState) => state.userSession.mfa?.sms?.requesting
